import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";

export const ProtectedRoute = () => {
  const { isAuthenticated, isStaff, hydrated } = useAuthStore();

  if (!hydrated) {
    return (
      <div className="page-center">
        <div className="spinner" />
      </div>
    );
  }

  if (!isAuthenticated || !isStaff) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
